import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useUserActions } from "../../functions/useUserActions";
import { motion } from "framer-motion";
import { Button } from "react-bootstrap";
import { useRecoilState } from "recoil";
import { isModalAtom } from "../../atoms";
import { SHA256 } from "crypto-js";

function LoginModal() {
  const [, setisMocalopen] = useRecoilState(isModalAtom);
  const handleClose = () => setisMocalopen(false);
  const [activeTab, setActiveTab] = useState("login");

  // Function to switch between login and signup tabs
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const userActions = useUserActions();
  const param = useLocation();

  // Validation schema for the form fields using Yup
  const validationSchema = Yup.object().shape({
    email: Yup.string().required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  const formOptions = { resolver: yupResolver(validationSchema) };
  const { register, handleSubmit, setError, formState } = useForm(formOptions);
  const { errors, isSubmitting } = formState;

  // Function to handle form submission
  function onSubmit({ email, password }) {
    return userActions
      .login(email, SHA256(password).toString(), param)
      .catch((error) => {
        setError("apiError", { message: error });
      });
  }

  return (
    <>
      <div className="card">
        <div className="card-header row">
          <div className="col-6 text-start">
            {activeTab === "login" && <h4>Login</h4>}
            {activeTab === "signup" && <h4>Register</h4>}
          </div>
          <div className="col-6 text-end">
            <button
              type="button"
              className="btn-close text-center mt-1"
              aria-label="Close"
              onClick={handleClose}
            ></button>
          </div>
        </div>
        {/* Error message for API error */}
        {errors.apiError && (
          <div className="alert alert-danger mt-3 mb-0">
            email 또는 pw를 확인하여 주세요
          </div>
        )}
        <div className="card-body">
          {/* Login form */}
          {activeTab === "login" && (
            <form onSubmit={handleSubmit(onSubmit)}>
              <div style={{ height: "500px" }}>
                <div className="form-group">
                  <label>Email</label>
                  <input
                    name="email"
                    type="text"
                    {...register("email")}
                    className={`form-control ${
                      errors.email ? "is-invalid" : ""
                    }`}
                  />
                  <div className="invalid-feedback">
                    {errors.email?.message}
                  </div>
                </div>
                <div className="form-group">
                  <label>Password</label>
                  <input
                    name="password"
                    type="password"
                    {...register("password")}
                    className={`form-control ${
                      errors.password ? "is-invalid" : ""
                    }`}
                  />
                  <div className="invalid-feedback">
                    {errors.password?.message}
                  </div>
                </div>
                <div className="col-6 offset-3 mt-5 pt-5">
                  <div class="d-grid gap-2">
                    {/* Login button */}
                    <Button
                      as={motion.button}
                      whileHover={{ scale: 1.2 }}
                      whileTap={{ scale: 0.9 }}
                      transition={{
                        type: "spring",
                        stiffness: 400,
                        damping: 17,
                      }}
                      disabled={isSubmitting}
                      variant="primary"
                    >
                      {isSubmitting && (
                        <span className="spinner-border spinner-border-sm mr-1" />
                      )}
                      Login
                    </Button>
                  </div>
                </div>
                {/* Switch to signup tab */}
                <div className="col-6 offset-3 mt-5">
                  <div class="d-grid gap-2">
                    <Button
                      type="button"
                      as={motion.button}
                      whileHover={{ scale: 1.2 }}
                      whileTap={{ scale: 0.9 }}
                      transition={{
                        type: "spring",
                        stiffness: 400,
                        damping: 17,
                      }}
                      variant="secondary"
                      onClick={() => handleTabChange("signup")}
                    >
                      회원가입
                    </Button>
                  </div>
                </div>

                {/* Additional link buttons */}
                <div className="row mt-5 justify-content-md-center">
                  <div className="col-1 p-0">
                    <div class="d-grid">
                      <Button
                        type="button"
                        as={motion.button}
                        whileHover={{ scale: 1.2 }}
                        whileTap={{ scale: 0.9 }}
                        transition={{
                          type: "spring",
                          stiffness: 400,
                          damping: 17,
                        }}
                        variant="info"
                      >
                        Link1
                      </Button>
                    </div>
                  </div>
                  <div className="col-1 p-0 offset-1">
                    <div class="d-grid">
                      <Button
                        type="button"
                        as={motion.button}
                        whileHover={{ scale: 1.2 }}
                        whileTap={{ scale: 0.9 }}
                        transition={{
                          type: "spring",
                          stiffness: 400,
                          damping: 17,
                        }}
                        variant="info"
                      >
                        Link2
                      </Button>
                    </div>
                  </div>
                  <div className="col-1 p-0 offset-1">
                    <div class="d-grid">
                      <Button
                        type="button"
                        as={motion.button}
                        whileHover={{ scale: 1.2 }}
                        whileTap={{ scale: 0.9 }}
                        transition={{
                          type: "spring",
                          stiffness: 400,
                          damping: 17,
                        }}
                        variant="info"
                      >
                        Link3
                      </Button>
                    </div>
                  </div>
                  <div className="col-1 p-0 offset-1">
                    <div class="d-grid">
                      <Button
                        type="button"
                        as={motion.button}
                        whileHover={{ scale: 1.2 }}
                        whileTap={{ scale: 0.9 }}
                        transition={{
                          type: "spring",
                          stiffness: 400,
                          damping: 17,
                        }}
                        variant="info"
                      >
                        Link4
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-3"></div>
              </div>
            </form>
          )}
          {/* Signup form */}
          {activeTab === "signup" && (
            <form onSubmit={handleSubmit(onSubmit)}>
              <div style={{ height: "500px" }}>
                <div className="form-group">
                  <label>Email</label>
                  <input
                    name="email"
                    type="text"
                    {...register("email")}
                    className={`form-control ${
                      errors.email ? "is-invalid" : ""
                    }`}
                  />
                  <div className="invalid-feedback">
                    {errors.email?.message}
                  </div>
                </div>
                <div className="form-group">
                  <label>Password</label>
                  <input
                    name="password"
                    type="password"
                    {...register("password")}
                    className={`form-control ${
                      errors.password ? "is-invalid" : ""
                    }`}
                  />
                  <div className="invalid-feedback">
                    {errors.password?.message}
                  </div>
                </div>
                <div className="form-group">
                  <label>Re-Password</label>
                  <input
                    name="password"
                    type="password"
                    {...register("password")}
                    className={`form-control ${
                      errors.password ? "is-invalid" : ""
                    }`}
                  />
                  <div className="invalid-feedback">
                    {errors.password?.message}
                  </div>
                </div>
                <br />
              </div>
              <div className="row">
                {/* Switch to login tab */}
                <div className="col-3">
                  <div class="d-grid gap-2">
                    <Button
                      type="button"
                      as={motion.button}
                      whileHover={{ scale: 1.2 }}
                      whileTap={{ scale: 0.9 }}
                      transition={{
                        type: "spring",
                        stiffness: 400,
                        damping: 17,
                      }}
                      variant="secondary"
                      onClick={() => handleTabChange("login")}
                    >
                      로그인
                    </Button>
                  </div>
                </div>
                {/* Signup button */}
                <div className="col-3 offset-6">
                  <div class="d-grid gap-2">
                    <Button
                      as={motion.button}
                      whileHover={{ scale: 1.2 }}
                      whileTap={{ scale: 0.9 }}
                      transition={{
                        type: "spring",
                        stiffness: 400,
                        damping: 17,
                      }}
                      disabled={isSubmitting}
                      variant="primary"
                    >
                      {isSubmitting && (
                        <span className="spinner-border spinner-border-sm mr-1" />
                      )}
                      회원가입
                    </Button>
                  </div>
                </div>
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
}

export default LoginModal;
